// extracted by mini-css-extract-plugin
export default {"noPreview":"MessageOverlay_noPreview__u7Scg","message":"MessageOverlay_message__0Gvlg"};